import React, { useEffect, useRef } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { api } from "../lib/api";
import { useAuth } from "../context/AuthContext";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function AuthCallback() {
  const navigate = useNavigate();
  const location = useLocation();
  const { setUser } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const hash = location.hash;
    const match = hash.match(/session_id=([^&]+)/);
    if (!match) {
      navigate("/");
      return;
    }
    const sessionId = match[1];
    // Strip the one-time token from the URL/history IMMEDIATELY after reading
    // it, so a failed, used, or in-flight token cannot be reused by Back,
    // refresh, or another login attempt.
    window.history.replaceState({}, document.title, location.pathname);
    (async () => {
      try {
        const { data } = await api.post("/auth/session", { session_id: sessionId });
        setUser(data);
        // Hard reload to /discover: lets AuthProvider re-read the fresh session
        // cookie via /auth/me on remount, avoiding a race where ProtectedRoute
        // sees user=null for one render tick and bounces back to the landing page.
        window.location.replace("/discover");
      } catch (e) {
        // URL already cleared above — just send the user home.
        navigate("/");
      }
    })();
  }, [location, navigate, setUser]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-background">
      <div className="text-center">
        <div className="w-12 h-12 border-4 border-primary border-t-transparent rounded-full animate-spin mx-auto mb-4" />
        <p className="text-muted-foreground font-serif text-lg">Welcoming you in…</p>
      </div>
    </div>
  );
}
